/* eslint @typescript-eslint/no-var-requires: "off" */
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { createHashRouter, RouterProvider } from 'react-router-dom'

import '@harvey-frontend/App.css'
import '@harvey-frontend/index.css'
import '@radix-ui/themes/styles.css'

import { initSentry, SentryDsns } from 'utils/sentry'

import { ConditionalTransition } from './components/transitions/ConditionalTransition'
import { PageTransition } from './components/transitions/PageTransition'

import App from './App'
import Main from './Main'
import AppSelectionScreen from './screens/AppSelectionScreen'
import InstructionEditScreen from './screens/InstructionEditScreen'
import PlaybookReviewScreen from './screens/PlaybookReviewScreen'
import { PlaybookRuleScreen } from './screens/PlaybookRuleScreen'
import PlaybookSelectionScreen from './screens/PlaybookSelectionScreen'

/* global document, Office */

const title = 'Harvey for Word'

const rootElement: HTMLElement = document.getElementById('container')!
const root = createRoot(rootElement)

initSentry(SentryDsns.HARVEY_FOR_WORD)

const createRouter = (platform: Office.PlatformType) =>
  createHashRouter([
    {
      path: '/',
      element: <App title={title} platform={platform} />,
      children: [
        {
          path: '',
          element: <Main />,
        },
        {
          path: 'app-selection',
          element: <AppSelectionScreen />,
        },
        {
          path: 'document-edit',
          element: <InstructionEditScreen />,
        },
        {
          path: 'playbook-selection',
          element: <PlaybookSelectionScreen />,
        },
        {
          path: 'playbook-review',
          element: (
            <ConditionalTransition>
              <PlaybookReviewScreen />
            </ConditionalTransition>
          ),
        },
        {
          path: 'playbook-rule/:index',
          element: (
            <PageTransition>
              <PlaybookRuleScreen />
            </PageTransition>
          ),
        },
      ],
    },
  ])

/* Render application after Office initializes */
void Office.onReady(
  (info: { host: Office.HostType; platform: Office.PlatformType }) => {
    // @ts-expect-error OfficeJS deletes these for some insane reason.
    // see https://stackoverflow.com/questions/42642863/office-js-nullifies-browser-history-functions-breaking-history-usage
    delete history.pushState
    // @ts-expect-error see above
    delete history.replaceState
    if (info.host !== Office.HostType.Word) {
      root.render(<div>Error: This add-in is only supported in Word.</div>)
    }
    root.render(<RouterProvider router={createRouter(info.platform)} />)
  }
)
